module.exports = __webpack_public_path__ + "img/kaist_gallery0.b11e9a52.jpg";